import { t } from '@lingui/macro'

export const getSearchPlaceholderText = (selectedGroup: string) => {
  if (selectedGroup !== '') {
    return t`Search within ${selectedGroup}`
  }
  return t`Search`
}
